export default __webpack_public_path__ + "static/media/SV.587ef432.svg";